import React from 'react';
import GlobalDbnTaxonomyDomainBasicInfoComponent from './global-dbn-taxonomy-domain-basic-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import GlobalDbnTaxonomyDomainAccountMappings from './global-dbn-taxonomy-domain-account-mappings';
import { useAppSelector } from '../../../../hooks/hooks';
import { selectListItems } from '../../../../redux/library/selector';
import TemplateComponent from './templates/template.component';
import { UploadMedia } from '../../../../common/components/common/upload-media';


export const GlobalDbnTaxonomyDomainComponent = ({ 
  setFunctionAttributes, 
  functionAttributes, 
  id, entityAttributes, 
  setEntityAttributes, 
  parentDomain, 
  handleInnerFormChange, 
  selectedDomain, 
  selectedTemplate,
  // handleFormItemChange,
   mediaFiles, 
   changeImage, 
   templateFiles,
   back, 
   handleFormTemplateItemChange,
   handleImageChange,
   handleTemplateSubmit,
   handleFormSubmit 
  }: any) => {
      const libraryData = useAppSelector(selectListItems)

  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <GlobalDbnTaxonomyDomainBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedDomain={selectedDomain}
        parentDomain={parentDomain}
      />,
      isVisible: true,
    },
    // {
    //   id: 2,
    //   title: ' Entity Attributes',
    //   component:
    //     <GlobalDbnTaxonomyDomainFunctionAndEntityAttributeComponent
    //       entityAttributes={entityAttributes}
    //       setEntityAttributes={setEntityAttributes}
    //       functionAttributes={functionAttributes}
    //       setFunctionAttributes={setFunctionAttributes}
    //       id={id}
    //     />,
    //   isVisible: id > 0 ? true : false,
    // },
    {
          id: 3,
          title: 'Media',
          component:

          <UploadMedia
            handleInnerFormChange={handleImageChange}
            mediaFilesList={mediaFiles}
            ownerTypeId={3}
            ownerId={id}
            folderName={'Domain'}
          />,
          isVisible: id > 0 ? true : false,
        },
        {
          id: 4,
          title: 'Templates',
          component:
            <>
            <TemplateComponent 
              selectedTemplate={selectedTemplate}
              handleInnerFormChange={handleInnerFormChange}              
              handleFormSubmit={handleTemplateSubmit}
              changeImage={changeImage}
              mediaFiles={templateFiles}
              handleFormAttachmentItemChange={handleFormTemplateItemChange}
            />
            </>,
          isVisible: id > 0 ? true : false,
        },
    {
      id: 5,
      title: 'DBA Mappings',
      component:
        <GlobalDbnTaxonomyDomainAccountMappings selectedDomain={selectedDomain} />,
      isVisible: id > 0 ? true : false,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default GlobalDbnTaxonomyDomainComponent;
